export default "__VITE_ASSET__BnfkKBDR__"